import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { ClickToDialViewMode } from "@/Common/Components/CallCenter/ClickToDial.types";
import { ClickToDialViewPhoneNumber } from "@/Common/Components/CallCenter/ClickToDialViewPhoneNumber";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { ContactRenderHelper } from "@/Common/Helpers/ContactRenderHelper";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";

interface IPhonesViewProps {
    phones: PhoneNumber[];
}

function PhonesView(props: IPhonesViewProps): JSX.Element {
    const validationHelper = new ValidationHelper();
    const { getText } = useTranslation();

    const listView: JSX.Element = (
        <>
            {props.phones.map(phoneNumber => {
                let phoneElement: JSX.Element;
                const displayPhoneType = `${MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(phoneNumber.ContactPointTypeLookupId))} - ${MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(phoneNumber.PhoneTypeLookupId))}`;
                const callCenterFeatureFlag: boolean = cacheStore.ClinicSettings.IsCallCenterEnabled();
                if (callCenterFeatureFlag) {
                    phoneElement = <ClickToDialViewPhoneNumber viewMode={ClickToDialViewMode.Hyperlink} phoneNumber={phoneNumber} forActivePatient />;
                }
                else {
                    const validationRule = validationHelper.getPhoneNumberValidationRule(phoneNumber.CountryLookupId, null); // no need for region when checking for phone number format?
                    const displayFormatSelector = validationRule?.DisplayFormatSelectorPatern ?? "";
                    const displayFormatSubstitution = validationRule?.DisplayFormatSubstitution ?? "";
                    let formattedPhone = validationHelper.getFormatedString(phoneNumber.Number, displayFormatSelector, displayFormatSubstitution);

                    if (phoneNumber.Extension)
                        formattedPhone += " Ext. " + phoneNumber.Extension;

                    phoneElement = <>{formattedPhone}</>;
                }
                return (
                    <tbody key={`phone_${phoneNumber.ContactPoint_id}`}>
                        {ContactRenderHelper.renderRow(
                            getText("TypeLabel"),
                            displayPhoneType,
                            "patientProfile-contacts-phone-type"
                        )}
                        {ContactRenderHelper.renderRow(
                            getText("CountryLabel"),
                            cacheStore.GetLocalizedValueByLookupId(phoneNumber.CountryLookupId),
                            "patientProfile-contacts-phone-country"
                        )}
                        {ContactRenderHelper.renderRow(
                            getText("NumberLabel"),
                            phoneElement,
                            "patientProfile-contacts-phone-number"
                        )}
                        {ContactRenderHelper.renderRow(
                            getText("NotesLabel"),
                            phoneNumber.Notes,
                            "patientProfile-contacts-phone-notes"
                        )}
                        {phoneNumber.NotificationsEnabled &&
                        ContactRenderHelper.renderRow(
                            null,
                            <CheckboxControl
                                disabled
                                checked={phoneNumber.NotificationsEnabled}
                                label={getText("NotifyPatientLabel")}
                            />,
                            "patientProfile-contacts"
                        )
                        }
                        <tr style={{ "height": "20px" }}>
                            <td className="c1" />
                            <td className="c2" />
                        </tr>
                    </tbody>
                );
            })}
        </>
    );

    return (
        <>
            <div><span>{getText("PhoneLabel")}</span></div>
            <div>
                <table>
                    {props.phones.any() ? listView : ContactRenderHelper.renderEmptyView("phones")}
                </table>
            </div>
        </>
    );
}

export { PhonesView };
